import styled from 'styled-components'

export const BlogStartYourDesignBannerContainer = styled.div`
  width: 100%;
  height: 230px;
  background: #faf1da;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 80px;

  & h2 {
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 0;
    margin-top: 0;
  }

  & p {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    width: 201px;
    text-align: center;
    margin-top: 10px;
  }

  & img {
    width: 226px;
    height: 124px;
    margin-top: -20px;
  }
`

export const CtaButton = styled.a`
  flex-grow: 0;
  flex-shrink: 0;
  background: linear-gradient(
    270deg,
    #ff9d74 0%,
    #ff5e6d 37.4%,
    #ff4f7e 74.69%,
    #ff6d90 100%
  );
  border-radius: 37px;
  width: 180px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  text-decoration: none !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  margin-bottom: -30px;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
      linear-gradient(
        270deg,
        #ff9d74 0%,
        #ff5e6d 37.4%,
        #ff4f7e 74.69%,
        #ff6d90 100%
      );
  }
`
